import React, {Component} from "react"
import {injectIntl} from 'react-intl'
import {Link} from "react-router"
import {connect} from "react-redux"
import Alert from "../components/Alert"
import Spinner from "../components/Spinner"
import {ACTION_RESET_PASSWORD_LOADING, getCurrentYear} from "../constants"
import {UserIsNotAuthenticated} from './AuthWrappers'

function mapStateToProps(state, ownProps) {
  const loading = state.resetPassword.loading
  const error = state.resetPassword.error
  const message = state.resetPassword.message

  return {
    loading,
    error,
    message,
  }
}

const mapDispatchToProps = {
  resetPassword: (emailAddress) => {
    return {
      type: ACTION_RESET_PASSWORD_LOADING,
      payload: emailAddress
    }
  }
}

class ForgotPassword extends Component {

  constructor() {
    super()
    this.state = {
      loading: false,
      error: null
    }
  }

  componentWillMount() {
    this.setState({loading: false, error: null})

  }

  componentWillReceiveProps(nextProps) {
    this.setState({loading: nextProps.loading, error: nextProps.error})
  }


  render() {

    const format = this.props.intl.formatMessage

    const clickHandler = ()=>{
      this.props.resetPassword(this.refs.emailAddress.value)
    }

    return (

      <div style={{width: '100%', height: '100%'}} className="gray-bg">
        <div className="passwordBox animated fadeInDown">
          <div className="row">

            <div className="col-md-12">
              <div className="ibox-content">
                <h2 className="font-bold">
                  {format({id:'password.reset'})}
                </h2>
                <p>
                  {format({id:'password.reset.desc'})}
                </p>
                <Alert show={this.state.error} message={this.state.error?this.state.error.message:""} />
                <Alert show={this.props.message} message={this.props.message?this.props.message:""} level="info"/>
                <Spinner show={this.state.loading}/>
                <div className="row">

                  <div className="col-lg-12">

                      <div className="form-group">
                        <input type="email" className="form-control"
                               placeholder={format({id:'input.placeholder.email'})}
                               required="" ref="emailAddress"></input>
                      </div>
                      <button type="submit" onClick={clickHandler} className="btn btn-primary inline half-width m-b">
                        {format({id:'send.new.password'})}
                      </button>
                      <Link to="/login" className="btn btn-primary inline half-width m-b pull-right">
                        {format({id:'back.to.login'})}
                      </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr/>
          <div className="row">
            <div className="col-md-12">
              <p className="m-t">
                <small>Neeuro Pte Ltd &copy; {getCurrentYear()}</small>
              </p>
            </div>
          </div>
        </div>
      </div>


    )
  }
}

export default {
  path: 'forgot_password',
  component: UserIsNotAuthenticated(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ForgotPassword)))
}



// WEBPACK FOOTER //
// ./src/routes/ForgotPassword.js